import React from 'react'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'
import KledoLoader from 'components/UI/KledoLoader'
import styles from './style.module.scss'

const Loader = ({ spinning = true, fullScreen = false }) => (
  <div
    className={classNames(styles.loader, {
      [styles.hidden]: !spinning,
      [styles.fullScreen]: fullScreen,
    })}
  >
    <KledoLoader size={48} />
    <span className={styles.text}>
      <FormattedMessage id="app.loading.page" />
    </span>
  </div>
)

export default Loader
